import { Component, Input } from "@angular/core";
import { NgbTooltipModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { SharedModule } from "src/shared/shared.module";
import { PipesModule } from "src/utils/pipes/pipes.module";
import { AboutComponent } from "src/app/pages/about-us/components/about/about.component";
import { Blog } from "src/app/services/model/blog.model";
import { CommonModule } from "@angular/common";
import { blogCoverArt, blogCoverTint } from "src/app/config/blog-cover";

@Component({
  selector: "app-blog-item",
  imports: [
    SharedModule,
    PipesModule,
    NgbTooltipModule,
    TranslateModule,
    CommonModule,
  ],
  templateUrl: "./blog-item.component.html",
  styleUrl: "./blog-item.component.scss",
})
export class BlogItemComponent {
  @Input() data: Blog;

  fileUrl = environment.apiFileUrl;

  coverTint(): string {
    return blogCoverTint(this.data?.id);
  }

  coverArt(): string {
    return blogCoverArt(this.data?.id);
  }
}
